import { styled } from '@mui/material/styles';
import { TRANSPARENT_COLOR, COLOR } from '@src/styles/color';
import { BREAKPOINTS } from '@src/styles/config';

export const StyledRequestsList = styled('div')`
  padding: 16px 24px 0px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledRequestsListContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledRequestsListHeader = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: 926px) {
    .title-request {
      font-size: 16px;
      line-height: 24px;
    }
  }

  @media only screen and (max-width: 650px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .filter-item {
    display: flex;
    align-items: center;
    gap: 8px;

    @media only screen and (max-width: 650px) {
      width: 100%;
    }
  }

  .action-filter {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .filter-btn {
    position: relative;
    padding: 7px 8px;
    gap: 12px;
    color: ${COLOR.colorFilterInput};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid ${TRANSPARENT_COLOR.borderGray};

    img {
      width: 24px;
    }

    .circle-btn {
      position: absolute;
      top: 10%;
      left: 50%;
      width: 12px !important;
      height: 12px !important;
    }
  }
`;

export const StyledTableTitle = styled('div')`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  table-layout: fixed;
  width: 100%;
  display: flex;
  gap: 4px;
  max-width: 505px;
  min-width: 350px;
  align-items: center;
  color: ${COLOR.darkBlue};
  font-weight: 550;

  @media only screen and (max-width: ${BREAKPOINTS.XL}px) {
    max-width: 392px;
  }

  .display-title {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .desc-requests {
      display: flex;
      align-items: center;
    }

    .title {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;

      .title-text {
        height: 28px;
        display: flex;
        align-items: center;
        width: fit-content;
        max-width: 80%;
        color: rgba(28, 28, 30, 1);
        margin-right: 8px;

        .text {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-size: 14px;
          font-weight: 510;
          line-height: 24px;
        }
      }
    }

    .title-desc {
      opacity: 0.8;
      font-size: 12px;
      font-style: normal;
      margin-right: 4px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: -0.4px;
      color: ${COLOR.label[80]};
    }
  }
`;
